import { useThemeSafe } from '../../contexts/ThemeContext';
import { useCustomColors } from '../../contexts/CustomColorsContext';
import { getThemeStyles } from '../../styles/themes';
import type { CountdownTimerComponent } from '../../schemas/validation';

export function useCountdownColors(data: CountdownTimerComponent['data']) {
  const { currentTheme } = useThemeSafe();
  const customColors = useCustomColors();
  const themeStyles = getThemeStyles(currentTheme, customColors || undefined);

  // PRIORITY: customColors (user explicit) > theme/brand package > stored data > fallback
  const headlineColor =
    data.customColors?.headline ||
    themeStyles.countdownTimer?.headline ||
    data.headlineColor ||
    '#111827';

  const subheadlineColor =
    data.customColors?.subheadline ||
    themeStyles.countdownTimer?.subheadline ||
    data.subheadlineColor ||
    '#6b7280';

  const numberColor =
    data.customColors?.number ||
    themeStyles.countdownTimer?.number ||
    data.numberColor ||
    '#3b82f6';

  const labelColor =
    data.customColors?.label || themeStyles.countdownTimer?.label || data.labelColor || '#6b7280';

  const textColor =
    data.customColors?.text || themeStyles.countdownTimer?.text || data.textColor || '#111827';

  return {
    headlineColor,
    subheadlineColor,
    numberColor,
    labelColor,
    textColor,
    themeStyles,
  };
}
